import Yup from '_zari/validation/_yup'

import { TiposDocumentoSunatConstant } from 'constants/index'
import TiposModalidadGuiaVenta from 'constants/tiposModalidadGuiaVenta'

export default Yup.object().shape({
  fechaEmision: Yup.string().required(),
  _idSedeDestino: Yup.string().required(),
  tipoDocumento: Yup.string().required(),
  serieDocumento: Yup.string().required(),
  numeroDocumento: Yup.number().required(),
  codigoMotivo: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE,
    then: Yup.string().required()
  }),
  fechaEntrega: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE,
    then: Yup.string().required()
  }),
  fechaTraslado: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE,
    then: Yup.string().required()
  }),
  modalidad: Yup.string().when('tipoDocumento', {
    is: TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE,
    then: Yup.string().required()
  }),
  _idTransportista: Yup.string().when('modalidad', {
    is: TiposModalidadGuiaVenta.PUBLICO,
    then: Yup.string().required()
  }),
  _idConductor: Yup.string().when('modalidad', {
    is: TiposModalidadGuiaVenta.PRIVADO,
    then: Yup.string().required()
  }),
  _idPlaca: Yup.string().when('modalidad', {
    is: TiposModalidadGuiaVenta.PRIVADO,
    then: Yup.string().required()
  })
})
